import React, { Component } from 'react'
import {message,Modal,DatePicker} from 'antd'
import moment from "moment";
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const { MonthPicker } = DatePicker;
export default class Exportcuredata extends Component {
    state = { 
        visible: false,
        confirmLoading: false,
        date: moment(),
        data:[]
    }

    // 月份字典与项目数据无关，首开一次；请求失败则下次打开自动重试
    dictLoaded = false

    getTime = () => {
        const {searchParams} = this.props;
        let monthTime = String(searchParams.month);
        if(monthTime.length == 1){
            monthTime = `0${monthTime}`
        }
        const time = String(searchParams.year)+monthTime;
        this.setState({date:moment(time)})
    }

    getMonthdata = () => {
        const options = {
            method: 'POST',
            url: API_URL.finance.queryRecordInvYearMonth,
            data: {},
            dataType: 'json',
            doneResult: res => {         
                this.dictLoaded = true;
                this.setState({
                    data:res
                })
            },
        };
        $.sendRequest(options);
    }

    disabledDate = (current) => {
        const { data:{ list = [] } = {} } = this.state;
        return !list.some( el => el == Number(current.format('YYYYMM')))
    }

    showModal = () => {
        if (!this.dictLoaded) {
            this.getMonthdata()
        }
        this.setState({
            visible: true,
        });
        this.getTime();
    }
    onChange = (date, dateString) => {
        this.setState({ date });
    }

    handleOk = () => {
        const {date} = this.state
        const options = {
            method: 'POST',
            url: API_URL.finance.exportPrepaidRecordList,
            data: {
                dateStart:date.format('YYYY-MM'),
                dateEnd:date.format('YYYY-MM'),
                needInvRecord:1
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    visible: false,
                });
            },
        };
        $.sendRequest(options);
    }

    handleCancel = () => {    
        this.setState({
            visible: false,
            date: moment(),
        })
    }

    render() {
    const {date} = this.state
    return (
        <div>
        <Modal
            title="导出固化数据"
            visible={this.state.visible}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
            width="400px"
        >
                <div className="filter-bar">
                    <div className="filter-bar-investigation">                    
                    <div className="form-item">
                        <label htmlFor="" className="ui-label">请先选择固化月份</label>
                            <MonthPicker
                                disabledDate={this.disabledDate}
                                placeholder="选择月份"
                                style={{width: 160}}
                                allowClear={true}
                                value={date}
                                onChange={this.onChange}
                            
                            />
                        </div>
                    </div>
                </div>
            
        </Modal>
        </div>
    )
}
}



// WEBPACK FOOTER //
// ./src/components/financeManagement/otherChargesReport/Exportcuredata.js